import { render } from "./quoteOne.vue?vue&type=template&id=2796dfce"
import script from "./quoteOne.vue?vue&type=script&lang=js"
export * from "./quoteOne.vue?vue&type=script&lang=js"

import "./quoteOne.vue?vue&type=style&index=0&id=2796dfce&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__